import { Descriptions, Empty } from 'antd';

import { IClassicSSO } from '../../../../api/interfaces/support/classic-sso';
import { useTranslate } from '../../../../hooks/translate';

type Props = {
  data?: IClassicSSO;
};

const ShowConfig = ({ data }: Props) => {
  const { t } = useTranslate();

  if (!data || !('id' in data)) {
    return <Empty description={t('support.classicSso.noConfigFound')} />;
  }

  return (
    <Descriptions title={t('support.classicSso.configTitle')} column={1}>
      <Descriptions.Item label={t('support.classicSso.ssoConfigId')}>
        {data.id}
      </Descriptions.Item>
      <Descriptions.Item label={t('support.classicSso.customerId')}>
        {data.qtCustomerId}
      </Descriptions.Item>
      <Descriptions.Item label={t('support.classicSso.ssoRoute')}>
        {data.ssoRoute}
      </Descriptions.Item>
    </Descriptions>
  );
};

export default ShowConfig;
